import { Component, OnInit, ElementRef, ViewChild, Input } from '@angular/core';

@Component({
  selector: 'app-switch-field',
  template: ``,
})

export class SwitchFieldComponent implements OnInit {
  @ViewChild('write') WriteField: any;
  @ViewChild('read') ReadField: any;

  // Flags
  @Input() public RorE: boolean = true; // Read or Write // True or False
  @Input() public showUpdateButt: Array<boolean> = [];


  constructor() {
  }

  ngOnInit() {
  }

  getValue() {
    if (this.WriteField)
      return this.WriteField.getValue();
    return undefined;
  }

  SwitchRorE() {
    this.RorE = !this.RorE;
    if(this.RorE) 
      this.showUpdateButt.pop();
    else {
      if (!this.showUpdateButt)
        this.showUpdateButt = [];
      this.showUpdateButt.push(true);
    }
  }
}
